<template>
    <div>
        <el-row style="margin-top: 2vh; padding: 20px;">
            <!-- 搜索表单区域 -->
            <el-col :span="24">
                <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                    <el-form-item label="搜索">
                        <el-input v-model="searchKeyword" placeholder="请输入配件名称或类型" clearable
                            @keyup.enter.native="handleSearch"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-plus" @click="showAddDialog()">新增</el-button>
                    </el-form-item>
                </el-form>
            </el-col>

            <!-- 表格区域 -->
            <el-col :span="24" style="margin-top: 20px;">
                <el-table ref="tableRef" :data="paginatedList" height="65vh" style="width: 100%;" border
                    :header-cell-class-name="'table-header'" @row-click="handleRowClick" v-loading="loading">
                    <el-table-column type="selection" width="55" align="center" />
                    <el-table-column label="序号" type="index" width="70" align="center" />
                    <el-table-column prop="deviceModel" label="模版名称" align="center" />
                    <el-table-column prop="accessoriesName" label="配件名称" align="center" />
                    <el-table-column prop="accessoriesType" label="配件类型" align="center" />
                    <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip />

                    <el-table-column label="操作" align="center" width="160" fixed="right">
                        <template slot-scope="scope">
                            <!-- <el-button size="small" class="text-red-500" @click="handleDelete(scope.row.id)"
                                type="danger" icon="el-icon-delete">删除</el-button> -->
                            <el-button @click="handleDelete(scope.row.id)" type="danger" size="small"
                                icon="el-icon-delete">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 分页区域 -->
                <div style="margin-top: 20px; text-align: center;">
                    <!-- 【核心修改】:total 绑定到新的计算属性 filteredTotalCount -->
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="filteredTotalCount">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>

        <!-- 新增/修改弹窗 (保持不变) -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" @close="resetForm" :z-index="3001"
            append-to-body>
            <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
                <el-form-item label="模版名称" prop="deviceModel">
                    <el-input v-model="form.deviceModel" placeholder="请输入模版名称" />
                </el-form-item>
                <el-form-item label="配件名称" prop="accessoriesName">
                    <el-input v-model="form.accessoriesName" placeholder="请输入配件名称" />
                </el-form-item>
                <el-form-item label="配件类型" prop="accessoriesType">
                    <el-input v-model="form.accessoriesType" placeholder="请输入配件类型" />
                </el-form-item>
                <el-form-item label="配件单位" prop="unit">
                    <el-input v-model="form.unit" placeholder="请输入配件单位" />
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getModelLinkAccessories, addModelLinkAccessories, delModelLinkAccessories } from "@/api/accessories";

export default {
    data() {
        return {
            // 表格数据和分页
            list: [], // 原始完整数据
            loading: false,
            currentPage: 1,
            pageSize: 10,
            // 【核心修改】totalCount 已从 data 中移除，改为计算属性

            // 搜索关键词
            searchKeyword: '',

            // 搜索表单
            searchForm: {
                houseId: '',
                code: '',
            },

            // 对话框和表单
            dialogVisible: false,
            dialogTitle: '新增配件',
            formRef: null,
            form: {
                id: '',
                accessoriesName: '',
                accessoriesType: '',
                remark: '',
                unit: '',
                userid: localStorage.getItem('userId')
            },

            // 表单校验规则
            rules: {
                accessoriesName: [{ required: true, message: '请输入配件名称', trigger: 'blur' }],
                accessoriesType: [{ required: true, message: '请输入配件类型', trigger: 'blur' }],
            },
        };
    },
    computed: {
        // 【核心修改】1. 新增一个计算属性，专门用于过滤
        filteredList() {
            if (!this.searchKeyword) {
                return this.list;
            }
            const keyword = this.searchKeyword.toLowerCase();
            return this.list.filter(item =>
                item.accessoriesName.toLowerCase().includes(keyword) ||
                item.accessoriesType.toLowerCase().includes(keyword)
            );
        },
        // 【核心修改】2. 新增一个计算属性，用于获取过滤后的总数
        filteredTotalCount() {
            return this.filteredList.length;
        },
        // 【核心修改】3. 修改 paginatedList，使其依赖 filteredList
        paginatedList() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            // 直接对过滤后的列表进行分页
            return this.filteredList.slice(start, end);
        }
    },
    created() {
        this.getList();
    },
    methods: {
        // 获取列表数据
        getList() {
            this.loading = true;
            getModelLinkAccessories({
                userid: localStorage.getItem('userId')
            }).then(response => {
                this.list = response.data;
            }).finally(() => {
                this.loading = false;
            });
        },

        // 处理搜索 (主要用于回车事件，重置页码)
        handleSearch() {
            this.currentPage = 1; // 每次搜索都从第一页开始
        },

        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1; // 切换每页数量时，页码重置为1
        },

        handleCurrentChange(val) {
            this.currentPage = val;
        },

        handleRowClick(row) {
            console.log('Row clicked:', row);
        },

        resetForm() {
            this.form = {
                id: '',
                accessoriesName: '',
                accessoriesType: '',
                remark: '',
                unit: ''
            };
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            }
        },

        showAddDialog() {
            this.dialogTitle = '新增配件';
            this.resetForm();
            this.dialogVisible = true;
        },

        submitForm() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    if (this.form.id) {
                        this.$message.success('修改成功');
                        this.dialogVisible = false;
                        this.getList();
                    } else {
                        addModelLinkAccessories(this.form).then(response => {
                            if (response.code === 200) {
                                this.$message.success('新增成功');
                                this.dialogVisible = false;
                                this.getList();
                            } else {
                                this.$message.error(response.msg || '新增失败');
                            }
                        }).catch(error => {
                            console.error("新增失败:", error);
                            this.$message.error('操作失败，请稍后重试');
                        });
                    }
                } else {
                    console.log('校验失败!');
                    return false;
                }
            });
        },

        handleDelete(id) {
            this.$confirm('此操作将永久删除该配件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const response = await delModelLinkAccessories({ id: id });
                    if (response.code === 200) {
                        this.$message.success('删除成功');
                        this.getList();
                    } else {
                        this.$message.error(response.msg || '删除失败');
                    }
                } catch (error) {
                    console.error("删除失败:", error);
                    this.$message.error('操作失败，请稍后重试');
                }
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },
    }
};
</script>

<style lang="scss" scoped>
.table-header {
    background-color: rgb(230, 242, 255) !important;
    font-weight: bold;
}

.text-red-500 {
    color: #f56c6c;
}

.demo-form-inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
}

.el-dialog__body {
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;
}

.el-form-item {
    margin-bottom: 20px;
}

.dialog-footer {
    display: flex;
    justify-content: flex-end;
}
</style>